import { Controller } from "@hotwired/stimulus";

// Render one PubMed link per line of the search-terms textarea, so a curator can click
// through and see whether a query actually returns anything before saving. The links track
// what is currently typed rather than what was last saved, which is the whole point: a term
// is usually wrong at the moment you are writing it, not after a round trip.
export default class extends Controller {
  static targets = ["input", "links"];

  static PUBMED_SEARCH = "https://pubmed.ncbi.nlm.nih.gov/?term=";

  connect() {
    this.render();
  }

  render() {
    const terms = this.inputTarget.value
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    this.linksTarget.replaceChildren(...terms.map((term) => this.buildLink(term)));
  }

  buildLink(term) {
    const anchor = document.createElement("a");
    anchor.href = `${this.constructor.PUBMED_SEARCH}${encodeURIComponent(term)}`;
    anchor.target = "_blank";
    anchor.rel = "noopener";
    anchor.textContent = term;
    anchor.className =
      "inline-flex cursor-pointer items-center rounded-full border border-line bg-card px-3 py-1.5 text-[12px] text-ink-muted transition hover:bg-paper-2 hover:text-ink";
    return anchor;
  }
}
